module.exports = __webpack_public_path__ + "static/media/logo_main.3ea52eee.gif";